import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-same-day-appointment-dialog',
  templateUrl: './same-day-appointment-dialog.component.html',
  styleUrl: './same-day-appointment-dialog.component.scss'
})
export class SameDayAppointmentDialogComponent {
constructor(
    public dialogRef: MatDialogRef<SameDayAppointmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel() {
    this.dialogRef.close('cancel');
  }

  onContinue() {
    this.dialogRef.close('continue');
  }
}
